<template>
  <div class="mobile">
<!--    <a href="https://if.geekpark.net/ticketcenter/" target="_blank">-->
<!--      <img src="https://summit-img.geekpark.net/%E5%8D%B3%E5%88%BB%E9%94%81%E7%A5%A8.svg"-->
<!--           style="position: fixed; width: 25vw; right: 3vw; bottom: 3vw; z-index: 1000;" class="ticket">-->
<!--    </a>-->
    <Header></Header>
    <MeteorShower></MeteorShower>
    <Video></Video>
    <Brief></Brief>
    <Schedule v-on:updatePartners="setPartnerValue"></Schedule>
    <Forum></Forum>
    <Museum></Museum>
    <StokeTake></StokeTake>
    <Subscribe></Subscribe>
    <LockTicket></LockTicket>
    <Partners :partner_categories="partner_categories"></Partners>
    <Footer></Footer>

    <div class='video_wrapper' id='ifx_video_iframe_wrapper' style='display:none;'>
      <div class='innner_black_bg' />
      <iframe
        id='ifx_video_iframe'
        style='position: absolute; width: 100%; height: 100%; left: 0; top: 0;z-index: 99'
        src=''
        frameborder='no'
        scrolling='no'
      ></iframe>
      <div class="close_btn_line"/>
      <img
        alt='关闭视频'
        class='close_video_btn'
        src='https://summit-img.geekpark.net/r2020/close_video_btn.svg'
        @click='closeVideo'
      />
    </div>
  </div>
</template>

<script>
import Header from '@/views/HomeMobile/components/Header.vue'
import MeteorShower from '@/views/HomeMobile/components/MeteorShower.vue'
import Video from '@/views/HomeMobile/components/Video.vue'
import Brief from '@/views/HomeMobile/components/Brief.vue'
import Schedule from '@/views/HomeMobile/components/Schedule.vue'
import Museum from '@/views/HomeMobile/components/Museum.vue'
import StokeTake from '@/views/HomeMobile/components/StokeTake.vue'
import Subscribe from '@/views/HomeMobile/components/Subscribe.vue'
import Partners from '@/views/HomeMobile/components/Partners.vue'
import Forum from '@/views/HomeMobile/components/Forum.vue'
import LockTicket from '@/views/HomeMobile/components/LockTicket.vue'
import Footer from '@/views/HomeMobile/components/Footer.vue'

export default {
  name: 'HomeMobile',
  components: {
    Header,
    MeteorShower,
    Video,
    Brief,
    Schedule,
    Museum,
    StokeTake,
    Subscribe,
    Partners,
    Forum,
    LockTicket,
    Footer
  },
  data () {
    return {
      partner_categories: [
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] }
      ]
    }
  },
  mounted () {
    window.history.scrollRestoration && (window.history.scrollRestoration = 'manual')
    window.onload = () => {
      const id = location.hash
      const navsHeight = document.body.offsetWidth * 0.18
      const marginTop = 0.12 * document.body.offsetWidth
      if (id === '#lock-ticket') {
        const timer = setInterval(() => {
          if (document.querySelectorAll('.item-one').length >= 29) {
            clearInterval(timer)
            setTimeout(() => {
              document.scrollingElement.scrollTop = this.getElementTop(document.querySelector('#lock-ticket')) - navsHeight - marginTop
            }, 200)
          }
        }, 20)
      } else if (id) {
        document.scrollingElement.scrollTop = this.getElementTop(document.querySelector(id)) - navsHeight
      }
    }
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    setPartnerValue (value) {
      this.partner_categories = value
    },
    closeVideo () {
      const vIframeWrapper = document.getElementById(
        'ifx_video_iframe_wrapper'
      )
      const vIframe = document.getElementById('ifx_video_iframe')
      vIframeWrapper.style.display = 'none'
      vIframe.src = ''
    }
  }
}
</script>

<style scoped lang="less">
  .mobile {
    width: 100%;
    background: url("https://summit-img.geekpark.net/mobile/%E8%83%8C%E6%99%AF-%E7%BA%BF.svg") 0 0 ~"/" 100% auto no-repeat;

    .video_wrapper {
      position: fixed;
      width: 90vw;
      height: 51vw;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #000;
      z-index: 9;
      .close_btn_line{
        position: absolute;
        top: -32px;
        left: 50%;
        height: 60px;
        width: 4px;
        border-left: 1px solid #000;
      }
      .close_video_btn {
        position: absolute;
        top: -48px;
        left: 50%;
        transform: translateX(-50%);
        height: 26px;
        width: auto;
        z-index: 98;
        &:hover {
          cursor: pointer;
        }
      }
      .innner_black_bg {
        background: #000;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
    }
  }
</style>
